import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { videos } from "@/mocks/videos";

export default function CategoryGrid() {
  return (
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
      {categories.map((category) => {
        const count = videos.filter((video) => video.category === category.slug).length;
        return (
          <Link
            key={category.slug}
            to={`/category/${category.slug}`}
            className="group flex flex-col gap-3 rounded-lg border border-background-200 bg-background-50 p-4 transition-all duration-300 hover:border-primary-200 hover:bg-primary-50/60 md:p-5"
          >
            <div className="flex items-center justify-between">
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700 transition-colors duration-300 group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${category.icon} text-xl`}></i>
              </span>
              <span className="rounded-full bg-background-100 px-2.5 py-1 text-xs text-foreground-500">{count} 个视频</span>
            </div>
            <div>
              <h3 className="font-heading text-base font-semibold text-foreground-900 group-hover:text-primary-700">
                {category.name}
              </h3>
              <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-500">{category.description}</p>
            </div>
          </Link>
        );
      })}
    </div>
  );
}